export enum MenuButtonType {
    OPEN = 'open',
    CLOSE = 'close',
}
